module.exports = __webpack_public_path__ + "img/ace-of-spades-display.82462be7.png";